// 组件对象，大写
import proportionInput from './proportionInput.vue'
export default proportionInput
